import config from '@/config'
import axios from 'axios'

export const glapiHttpInst = axios.create({
  baseURL: config.glapiBaseUri,
  timeout: 5000 // TODO: config envs!
})
